import Model, { attr, belongsTo } from '@ember-data/model';

export default class RedirectionToken extends Model {
  @attr('string') flowUserType;
  @attr('string') ownerEmail;
  @attr('string') partnerName;
  @attr('string') ownerFirstName;
  @attr('string') organizationName;
  @attr('string') organizationId;
  @attr('string') flowType;
  @attr('string') organizationLegalCountry;
  @attr('string') legalFlow;
  @attr('string') locale;
  @attr('string') partnerType;
  @attr('boolean') companyCreationFromScratch;

  @belongsTo('registration', { async: true, inverse: null }) registration;

  get registrationID() {
    return this.belongsTo('registration').id();
  }

  get isAccountant() {
    return this.partnerType === 'accountant';
  }
}
